import {Component} from '@angular/core';
import {SeoService} from '../shared/services/seo.service';

@Component({
  templateUrl: './statute-page.component.html'
})
export class StatutePageComponent {
  public title: string;

  constructor(private seoService: SeoService) {
    this.title = 'Καταστατικό';
    this.seoService.addTags('Μπορείς να δεις το καταστατικό μας', 'assets/images/Home.png', this.title);
  }
}
